$(document).ready(function() {
    var vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", vh + "px");

    window.addEventListener("resize", function () {
        var vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty("--vh", vh + "px");
    });

    $('#hamburger').on('click', function() {
        $(this).toggleClass('page-header__hamburger--active');
        $('.main-menu').toggleClass('main-menu--active');
        $('.socials').toggleClass('socials--active');
        $('body').toggleClass('noscroll');
    });

    // Scroll down arrow
    $('.scroll-arrow').on('click', function() {
        $('html, body').animate({
            scrollTop: $("#scrollPoint").offset().top + 50
        }, 1000);
    });

    // Slick slider
    const sliderSettings = {
        infinite: true,
        speed: 500,
        fade: true,
        cssEase: 'linear',
        autoplay: true,
        arrows: false,
        pauseOnHover: false,
        autoplaySpeed: 4000
    }
    $('.slider').slick(sliderSettings);

    // Slider for homepage logos
    const homepageLogosSliderSettings = {
        arrows: false,
        slidesToShow: 6,
        slidesToScroll: 1,
        infinite: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 2,
                }
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 2,
              }
            },
            {
              breakpoint: 800,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            }
        ]
    }
    $('.homepage__logo-row').slick(homepageLogosSliderSettings);

});